import React from 'react';

export default function PegasusDashboard() {
  return <h1>Pegasus Dashboard Page</h1>;
}
